import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ResolveEnd, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter, take, takeUntil } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { OpenCartDialogs } from 'src/app/theme/utils/open-cart-dialog';
import { checkDeliveryCalenderAndCutOffTime } from 'src/app/theme/utils/util-functions';
import { Subject, Subscription } from 'rxjs';
import { SharedDataService } from '../services/sharedata.service';
import { MatDialog } from '@angular/material/dialog';
import { SignInUpRedirectComponent } from 'src/app/main-theme/global-theme/pages/sign-in/sign-in-up-redirect/sign-in-up-redirect.component';
import { SubscriptionService } from '../services/subscription.service';
import { AppSettings, Settings } from 'src/app/app.settings';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { UserDetailsResolver } from '../resolvers/user-details.service';
import { StoreService } from '../resolvers/store.service';
import { FocusMonitor } from '@angular/cdk/a11y';
@Component({
  selector: 'app-search-products',
  templateUrl: './search-products.component.html',
  styleUrls: ['./search-products.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchProductsComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() store: object;
  @Input() user: object;
  searchInput = new FormControl();
  @Input() showSearchResult: boolean;
  searchProducts: any[] = [];

  removeSearchBarBottomBorders: boolean = false;
  showSearchResultNotFoundMsg: boolean = false;
  featureTags = {};
  numFound: number = 0;
  page: number = 0;
  limit: number = 30;
  searchKey: string = '';
  searchKeyLength: number = 0;
  ftagResultMobile: boolean = false;
  loading: boolean
  showSkeletonLoader:  boolean;

  previousSearchSubscription: Subscription;
  protected unSubscribe$: Subject<void> = new Subject<void>();
  private destroy$ = new Subject<void>();
  @ViewChild('initialFocus') initialFocus: ElementRef;
  themeType: any;
  public settings: Settings;
  userDetails = {};
  storeDetails = {};
  paymentCashOnDelivery = {};
  constructor(
    private dialog: MatDialog,
    private apiService: ApiService,
    private router: Router,
    private openCartDialogs: OpenCartDialogs,
    private sharedDataService: SharedDataService,
    private subscription: SubscriptionService,
    public appSettings: AppSettings,
    private userDetailsResolver: UserDetailsResolver,
    private storeService: StoreService,
    private _focusMonitor: FocusMonitor
    
  ) {
    this.settings = this.appSettings.settings;
   }
  ngAfterViewInit(): void {
    this.initialFocus.nativeElement.focus()
  }

  ngOnInit(): void {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.ftagResultMobile =  (!!this.featureTags && this.featureTags['ftag_sf_search_bar_ui_changes']) ? true : false;
    this.themeType = this.settings['themeType']
    this.searchInput.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.searchKey = value.trim();
        // cancel the previous request
        if (this.previousSearchSubscription) {
          this.previousSearchSubscription.unsubscribe();
          this.previousSearchSubscription = null;
        }
        this.searchProductsFormSolr("loadfresh");
      });

    this.router.events
      .pipe(filter(event => event instanceof ResolveEnd))
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.searchInput.setValue('');
        this.page = 0;
        this.numFound = 0;
        this.searchProducts = [];
        this.removeSearchBarBottomBorders = false;
        this.showSearchResultNotFoundMsg = false;
      });
    if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
      this.userDetailsResolver.resolve().subscribe(data => {
        this.userDetails = data['response']['data']['users'];
      });
      this.storeService.resolve().subscribe(data => {
        this.storeDetails = ['payment_method_details'];
        this.paymentCashOnDelivery = data['response']['data']['payment_method_details'][0];
      });
    }
  }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.destroy$.next();
    this.destroy$.complete();
  }
  resultScrollHandler(e: any) {
    let { scrollTop, scrollHeight, clientHeight } = e.target;
    const isBottomReached = scrollTop + clientHeight >= scrollHeight - 5;

    if (isBottomReached && !this.loading) {
      this.loading = true;      
      this.searchProductsFormSolr("loadmore").finally(() => {
        this.loading = false; 
      });
    }  
  }

  searchProductsFormSolr(type: 'loadfresh' | 'loadmore'): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.searchKeyLength = this.searchKey.length;
      if (this.searchKeyLength > 0) {
        (type === "loadfresh") ? (this.page = 0) : (this.page += 1);
        let params = {
          search: this.searchKey,
          page: this.page,
          limit: this.limit,
        };
        if (type === 'loadmore' && this.numFound === this.searchProducts.length) {
          resolve(); // Resolve immediately if no more data to load
          return;
        }
        this.showSkeletonLoader = true;
        if(!!this.featureTags && this.featureTags['sf_solr_search_product']){
        const apiMethod = this.apiService.loggedIn()
        ? this.apiService.getSearchProductsInSolr(params)
        : this.apiService.searchProductsInSolr(params);
        this.previousSearchSubscription = apiMethod
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe({
            next: (result: any) => {
              this.showSkeletonLoader = false;
              const response = result.response;
              if (response.status === 1) {
                this.searchProducts = type === 'loadfresh'
                  ? response.documents
                  : [...this.searchProducts, ...response.documents];
                this.numFound = response.numFound;
              }
              // if search result is 0 then show warning message
              this.showSearchResultNotFoundMsg = this.searchProducts.length === 0 ? true : false;
              // if search request is success then remove search bar bottom border
              this.removeSearchBarBottomBorders = true;
              resolve(); // Resolve after successful API call
            },
            error: (err) => {
              this.showSkeletonLoader = false;
              console.error("Error loading products:", err);
              reject(err); // Reject on error
            },
          });
        }else{
          this.previousSearchSubscription = this.apiService.searchProductsInSolr(params)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe({
            next: (result: any) => {
              this.showSkeletonLoader = false;
              const response = result.response;
              if (response.status === 1) {
                this.searchProducts = type === 'loadfresh'
                  ? response.documents 
                  : [...this.searchProducts, ...response.documents];
                this.numFound = response.numFound;
              }
              // if search result is 0 then show warning message
              this.showSearchResultNotFoundMsg = this.searchProducts.length === 0 ? true : false;
              // if search request is success then remove search bar bottom border
              this.removeSearchBarBottomBorders = true;
              resolve(); // Resolve after successful API call
            },
            error: (err) => {
              this.showSkeletonLoader = false;
              console.error("Error loading products:", err);
              reject(err); // Reject on error
            },
          });
        }
      } else {
        this.page = 0;
        this.numFound = 0;
        this.searchProducts = [];
        this.removeSearchBarBottomBorders = false;
        this.showSearchResultNotFoundMsg = false;
        resolve(); // Resolve when there's no search key
      }
    });
  }

  addToCartBtnClicked(e: MouseEvent, product: Object) {
    this.hideSearch();
    this.setEmpty();
    if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
      if (this.apiService.loggedIn() === true) {
          if (!!product['product_event_ids'] && !! this.user['user_event_ids'] && product['product_event_ids'].some(eventId => this.user['user_event_ids'].includes(eventId))) {
              const dialogRef = this.dialog.open(PopupComponent, {
                  maxWidth: '96vw',
                  width: '450px',
                  data: { msg: 'This product cannot be ordered for your pickup location or route.',
                    restrict_product : true
                   }
              });
              return;
          }
      }
    }
    
    if (!!this.featureTags && this.featureTags['ftags_membership']) {
      if (product['is_membership'][0] == 1) {
        let membershipPoduct = 'membershipPoduct'; 
        if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
          if (this.apiService.loggedIn() === true) {
            if (this.userDetails['preferred_payment_method'] === "Credit Card") {
              this.apiService.getCreditCardList().subscribe(data => {
                if (data['response']['status'] == 6) {
                  this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
                  const dialogRef = this.dialog.open(PopupComponent, {
                    maxWidth: '96vw',
                    width: '450px',
                    data: {
                      msg: this.paymentCashOnDelivery['is_sf_active'] === 1
                        ? 'Cash On Delivery'
                        : 'Credit card Not Found',
                        type: 'membership'
                    }
                  });
                  dialogRef.afterClosed().subscribe(result => {
                    if (result == 'Pay Later') {
                      const formattedProduct = {
                      product: {
                        id: product['id'] ? +product['id'] : null,
                        description: product['description'] || "",
                        retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                        type: product['type'] || "",
                        website_description: product['website_description'] || "",
                        product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                        product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                      }
                    };
                    sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                    this.router.navigate(['/membership-purchase']);
                    }
                  });
                  return;
                } else {
                  if (this.apiService.loggedIn() == true) {
                    const formattedProduct = {
                      product: {
                        id: product['id'] ? +product['id'] : null,
                        description: product['description'] || "",
                        retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                        type: product['type'] || "",
                        website_description: product['website_description'] || "",
                        product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                        product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                      }
                    };
                    sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                    this.router.navigate(['/membership-purchase']);
                  }
                }
              });
              return;
            } else {
              if (this.userDetails['preferred_payment_method'] === 'Cash On Delivery') {
                if (this.apiService.loggedIn() == true) {
                   const formattedProduct = {
                      product: {
                        id: product['id'] ? +product['id'] : null,
                        description: product['description'] || "",
                        retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                        type: product['type'] || "",
                        website_description: product['website_description'] || "",
                        product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                        product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                      }
                    };
                    sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                    this.router.navigate(['/membership-purchase']);
                } else {
                  const formattedProduct = {
                      product: {
                        id: product['id'] ? +product['id'] : null,
                        description: product['description'] || "",
                        retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                        type: product['type'] || "",
                        website_description: product['website_description'] || "",
                        product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                        product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                      }
                    };
                    sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                  if (!!this.redirectWithReturnUrl('membershipPoduct')) {
                    return;
                  }
                }
              } else {
                const dialogRef = this.dialog.open(PopupComponent, {
                  maxWidth: '96vw',
                  width: '450px',
                  data: { msg: this.paymentCashOnDelivery['is_sf_active'] === 1
                        ? 'Cash On Delivery'
                        : 'Credit card Not Found',
                        type: 'membership' }
                  
                });
                dialogRef.afterClosed().subscribe(result => {
                  if (result == true) {
                    this.router.navigate(['/account/payment']);
                    if (this.dialog.openDialogs.length > 0) {
                      this.dialog.closeAll();
                    }
                  }
                });
              }
            }
          }else{
            const formattedProduct = {
              product: {
                id: product['id'] ? +product['id'] : null,
                description: product['description'] || "",
                retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                type: product['type'] || "",
                website_description: product['website_description'] || "",
                product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
              }
            };
            sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
            if (!!this.redirectWithReturnUrl('membershipPoduct')) {
              return;
            }
          }
        }else{
          this.apiService.getCreditCardList().subscribe(data => {
          if (data['response']['status'] == 6) {
              this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
              const dialogRef = this.dialog.open(PopupComponent, {
                  maxWidth: '96vw',
                  width: '450px',
                  data: { msg: 'Credit card Not Found' }
              });
              return; 
            }else{
              if(this.apiService.loggedIn() == true) {
                const formattedProduct = {
                  product: {
                    id: product['id'] ? +product['id'] : null,
                    description: product['description'] || "",
                    retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                    type: product['type'] || "",
                    website_description: product['website_description'] || "",
                    product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                    product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                  }
                };
                sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                this.router.navigate(['/membership-purchase']);
              }else{
                const formattedProduct = {
                  product: {
                    id: product['id'] ? +product['id'] : null,
                    description: product['description'] || "",
                    retail_price: Array.isArray(product['retail_price']) ? product['retail_price'][0] : product['retail_price'] || 0,
                    type: product['type'] || "",
                    website_description: product['website_description'] || "",
                    product_image1: Array.isArray(product['product_image1']) ? product['product_image1'][0] : product['product_image1'] || null,
                    product_image2: Array.isArray(product['product_image2']) ? product['product_image2'][0] : product['product_image2'] || null,
                  }
                };
                sessionStorage.setItem("membership_item", JSON.stringify(formattedProduct));
                if (!!this.featureTags && this.featureTags['sf_enhance_registration']) {
                  if (product['is_membership'][0] == 1) {
                    this.router.navigate(['/sign-up']);
                    this.sharedDataService.setRedirectToMembership(true);
                  } else {
                    this.sharedDataService.setRedirectToMembership(false);
                  }
                } else {
                  this.sharedDataService.setRedirectToMembership(true);
                  const dialogRedirect = this.dialog.open(
                    SignInUpRedirectComponent,
                    {
                      width: "450px",
                      panelClass: ["product-dialog", "product-dailog-style"],
                      data: { membershipPoduct: membershipPoduct },
                    }
                  );
                  dialogRedirect.afterClosed().subscribe((result) => {
                    if (result) {
                      this.subscription.setEmitCloseDialogueSubjectNext();
                    }
                  });
                }
              }
            }
          });
          return;
 
        }
      }else{
        if (this.apiService.loggedIn() === false) {
      if (!!this.featureTags && this.featureTags['welcome_checkout_popup_issue']) {
        const dialogRedirect = this.dialog.open(
            SignInUpRedirectComponent,
            {
                width: "450px",
                panelClass: ["product-dialog","product-dailog-style"],
                data: {},
            }
        );

        dialogRedirect.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
            if (result) {
                this.subscription.setEmitCloseDialogueSubjectNext();
            }
        });
      }else{
          const dialogRedirect = this.dialog.open(
            SignInUpRedirectComponent,
            {
                width: "450px",
                panelClass: "product-dialog",
                data: {},
            }
        );

        dialogRedirect.afterClosed()
        .pipe(takeUntil(this.destroy$))
        .subscribe((result) => {
            if (result) {
                this.subscription.setEmitCloseDialogueSubjectNext();
            }
        });

      }

  }else{
    let spinnerClasses = ['routeworx-spinner', 'spinner-style3'];
    e.target['classList'].add(...spinnerClasses);
    e.target['disabled'] = true;
    let params = {
      website_url: product['website_url']
    }
    if (checkDeliveryCalenderAndCutOffTime() === true) {
      params['edit_cart'] = 3;
    }
    let refreshPages = [
      '/cart',
      '/account/orders',
      // '/account/recurring'
    ];
    let refreshSubscriptionName = [
      'refreshCartPageOrders',
      'refreshOrdersPageOrders',
      // 'refreshRecurringPageOrders'
    ];
    let refreshPagesIndex = refreshPages.indexOf(this.router.url);
    this.apiService.searchProducts(params)
      .pipe(take(1))
      .subscribe((result: any) => {
        let response = result.response;
        if (response.status === 1) {
          let products = response.data.products.products;
          let product = products[0];
          if (refreshPagesIndex !== -1) {
            product['subscriptionName'] = refreshSubscriptionName[refreshPagesIndex];
          }
          this.openCartDialogs.openDialog(this.store, this.user, product);
        }
        e.target['classList'].remove(...spinnerClasses);
        e.target['disabled'] = false;
      });
    }
      }
    }
    
  }
  hideSearch() {
    localStorage.setItem('checkVal', JSON.stringify(false))
  }
  setEmpty() {
    this.searchInput.setValue('');
  }
  searchNavigation(category, description, id) {
    // this.router.navigate(['categories/'+category+'/'+description+'/'+id]);
    this.router.navigate(['products/' + id]);
    localStorage.setItem('checkVal', JSON.stringify(false));
  }

  public redirectWithReturnUrl(membershipPoduct?: any): boolean {
    try {
      if (this.apiService.loggedIn() === false) {
        if (!!this.featureTags && this.featureTags['sf_enhance_registration']) {
          if (!!membershipPoduct) {
            this.router.navigate(['/sign-up']);
            this.sharedDataService.setRedirectToMembership(true);
          } else {
            this.sharedDataService.setRedirectToMembership(false);
              const dialogRedirect = this.dialog.open(
                SignInUpRedirectComponent,
                {
                  width: "450px",
                  panelClass: ["product-dialog", "product-dailog-style"],
                  data: { membershipPoduct: membershipPoduct },
                }
              );

              dialogRedirect.afterClosed()
                .pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                  if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                    setTimeout(() => {
                      const Button = document.getElementById('addToCartFullbtn');
                      if (Button) {
                        this._focusMonitor.stopMonitoring(Button);
                      }
                    }, 0);
                  }
                  if (result) {
                    this.subscription.setEmitCloseDialogueSubjectNext();
                  }
                });

              return true;
          }
        } else {
          if (!!this.featureTags && this.featureTags['welcome_checkout_popup_issue']) {
            const dialogRedirect = this.dialog.open(
              SignInUpRedirectComponent,
              {
                width: "450px",
                panelClass: ["product-dialog", "product-dailog-style"],
                data: { membershipPoduct: membershipPoduct },
              }
            );

            dialogRedirect.afterClosed()
              .pipe(takeUntil(this.destroy$))
              .subscribe((result) => {
                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                  setTimeout(() => {
                    const Button = document.getElementById('addToCartFullbtn');
                    if (Button) {
                      this._focusMonitor.stopMonitoring(Button);
                    }
                  }, 0);
                }
                if (result) {
                  this.subscription.setEmitCloseDialogueSubjectNext();
                }
              });

            return true;
          } else {
            const dialogRedirect = this.dialog.open(
              SignInUpRedirectComponent,
              {
                width: "450px",
                panelClass: "product-dialog",
                data: {},
              }
            );

            dialogRedirect.afterClosed()
              .pipe(takeUntil(this.destroy$))
              .subscribe((result) => {
                if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
                  setTimeout(() => {
                    const Button = document.getElementById('addToCartFullbtn');
                    if (Button) {
                      this._focusMonitor.stopMonitoring(Button);
                    }
                  }, 0);
                }
                if (result) {
                  this.subscription.setEmitCloseDialogueSubjectNext();
                }
              });

            return true;
          }
        }
      }
      else {
        return false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}
